import { render, staticRenderFns } from "./latestBlocks.vue?vue&type=template&id=35fb0cbc&scoped=true&"
import script from "./latestBlocks.vue?vue&type=script&lang=js&"
export * from "./latestBlocks.vue?vue&type=script&lang=js&"
import style0 from "./latestBlocks.vue?vue&type=style&index=0&id=35fb0cbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb0cbc",
  null
  
)

export default component.exports